import { Icon } from './Icon.js';

export type AdminRole =
  | 'super_admin'
  | 'superadmin'
  | 'admin'
  | 'support'
  | 'support_readonly'
  | string;

function isSuper(role: AdminRole): boolean {
  return role === 'super_admin' || role === 'superadmin';
}

function isSupport(role: AdminRole): boolean {
  return role === 'support' || role === 'support_readonly';
}

function roleClass(role: AdminRole): string {
  if (isSuper(role)) return 'super';
  if (isSupport(role)) return 'support';
  return '';
}

function roleLabel(role: AdminRole): string {
  if (isSuper(role)) return 'Süper Admin';
  if (role === 'admin') return 'Admin';
  if (role === 'support') return 'Destek';
  if (role === 'support_readonly') return 'Destek (Salt Okunur)';
  return role;
}

function roleIcon(role: AdminRole): React.FC<{ size?: number }> {
  if (isSuper(role)) return Icon.Shield;
  if (isSupport(role)) return Icon.Headset;
  return Icon.Key;
}

export interface RolePillProps {
  readonly role: AdminRole;
  readonly testId?: string;
}

export function RolePill({ role, testId }: RolePillProps): JSX.Element {
  const variant = roleClass(role);
  const className = ['role-pill', variant].filter(Boolean).join(' ');
  const IconComp = roleIcon(role);
  return (
    <span className={className} data-testid={testId}>
      <IconComp size={11} />
      {roleLabel(role)}
    </span>
  );
}
